import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserRole } from '../hooks/use-user-role';

export type PlatformAdminRouteProps = {
  children: ReactNode;
  fallback?: string;
};

/**
 * A wrapper to be used around routes which are only accessibly for Platform Admin users.
 * Other users will be redirected back to the fallback url if they access this url
 */
export const PlatformAdminRouteWrapper: FC<PlatformAdminRouteProps> = ({
  children,
  fallback = '/',
}) => {
  const { isPlatformAdmin } = useUserRole();

  return isPlatformAdmin ? children : <Navigate to={fallback} />;
};
